import { useEffect, useRef } from "react";
import axios from "axios";
import { useAPIToast } from "./useAPIToast";
import { useAuth } from "context/AuthContext";
import useSWR from "swr";

const REACT_APP_NFE_FADEL_BASE_URL_V2 =
  process.env.REACT_APP_NFE_FADEL_BASE_URL_V2 ||
  "https://dev.nfe.fadel.mixfiscal.com.br/api";

const REACT_APP_NFE_FADEL_TOKEN_API = process.env.REACT_APP_NFE_FADEL_TOKEN_API;

export const useApiNfeFadelV2 = () => {
  const onRejected = error => {
    return Promise.reject(error);
  };

  const apiRef = useRef(
    axios.create({
      baseURL: REACT_APP_NFE_FADEL_BASE_URL_V2,
      withCredentials: false,
    }),
  );

  apiRef.current.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${REACT_APP_NFE_FADEL_TOKEN_API}`;
    return config;
  });

  apiRef.current.interceptors.response.use(response => response, onRejected);

  return apiRef.current;
};

export const useAPINfeFadelV2 = () => {
  const api = useApiNfeFadelV2();

  const { onSend, isLoading, data } = useAPIToast(api);

  return {
    isLoading,
    data,
    onSend,
  };
};

export const useAPIFadelFetchV2 = (url, axiosConfigs, config) => {
  const api = useApiNfeFadelV2();
  const { tokenCompanies, revalidateAll, setRevalidateAll } = useAuth();

  const { data, error, mutate, revalidate, isValidating } = useSWR(
    url,
    async urlReturn => {
      if (axiosConfigs?.method === "POST") {
        const response = await api.post(urlReturn, axiosConfigs.data);
        return response.data;
      }

      const response = await api.get(urlReturn, axiosConfigs);
      return response.data;
    },
    config,
  );

  // Revalida todas as requisicoes para carregar os dados corretamente!
  useEffect(() => {
    if (revalidateAll?.length && axiosConfigs?.method !== "POST") {
      revalidate();
      setRevalidateAll();
    }
  }, [
    tokenCompanies,
    revalidate,
    revalidateAll,
    setRevalidateAll,
    axiosConfigs?.method,
  ]);

  return {
    data,
    error,
    isError: !!error,
    isLoading: (!error && !data && String(data) !== "") || isValidating,
    isValidating,
    mutate,
    revalidate,
  };
};
